import styled from "styled-components";
import { Table } from "@chakra-ui/react";

export const Container = styled.div`
  width: 90vw;
  margin: 50px auto;
  background-color: white;

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    h1 {
      font-size: 2.1875rem;
      font-weight: 600;
      color: #3f3d56;
    }
  }



  @media screen and (max-width: 500px) {
    .title {
      h1 {
        font-size: 25px;
      }
    }
  }
`;

export const StyledTable = styled(Table)`
  background-color: #ffffff;
  z-index: 2;
  position: relative;
`;
